import { render, staticRenderFns } from "./MasterMonitor.vue?vue&type=template&id=36dad45a&scoped=true&"
import script from "./MasterMonitor.vue?vue&type=script&lang=js&"
export * from "./MasterMonitor.vue?vue&type=script&lang=js&"
import style0 from "./MasterMonitor.vue?vue&type=style&index=0&id=36dad45a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dad45a",
  null
  
)

export default component.exports